import { InlineLoading } from "@carbon/react";
import React from "react";

import { useT } from "src/internationalization";

const Loading: React.FC = () => {
  const t = useT();
  return <InlineLoading status="active" iconDescription="Loading" description={t("app.loading")} />;
};

export default Loading;
